import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'life-insurance-fees-form',
    templateUrl: './life-insurance-fees-form.component.html',
    styleUrls: ['./life-insurance-fees-form.component.scss'],
    standalone: false
})
export class LifeInsuranceFeesFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  displayInitialFees: boolean = false;
  displayMonthlyFees: boolean = false;
  minInitialFees: number = 0;
  maxInitialFees: number = 100;
  minMonthlyFees: number = 0;
  maxMonthlyFees: number = 100;

  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);

    const pledge = this.subscriptionFacade.getPledge();

    this.initProductFeesValues(pledge);
  }

  initProductFeesValues(pledge: any) {
    const avInvestmentType =
      pledge?.products?.[0]?.parameters?.avInvestmentType;

    this.displayInitialFees = ['INITIAL_AND_MONTHLY', 'INITIAL'].includes(
      avInvestmentType,
    );
    this.displayMonthlyFees = ['INITIAL_AND_MONTHLY', 'MONTHLY'].includes(
      avInvestmentType,
    );

    if (!this.displayInitialFees) {
      this.products
        .get(`${0}`)
        .get('parameters')
        .get('initialPaymentFeesPercent')
        .setValidators([Validators.nullValidator]);
      this.form.updateValueAndValidity();
    }

    if (!this.displayMonthlyFees) {
      this.products
        .get(`${0}`)
        .get('parameters')
        .get('monthlyPaymentFeesPercent')
        .setValidators([Validators.nullValidator]);
      this.form.updateValueAndValidity();
    }

    if (this.displayInitialFees || this.displayMonthlyFees) {
      this.productDao
        .getProduct(pledge?.products?.[0]?.productId as any)
        .subscribe(product => {
          this.minInitialFees =
            this.displayInitialFees &&
            this.floorValue(product.lifeInsuranceMinInitialPaymentFee * 100);
          this.maxInitialFees =
            this.displayInitialFees &&
            this.floorValue(product.lifeInsuranceMaxInitialPaymentFee * 100);

          this.minMonthlyFees =
            this.displayMonthlyFees &&
            this.floorValue(product.lifeInsuranceMinProgrammedPaymentFee * 100);

          this.maxMonthlyFees =
            this.displayMonthlyFees &&
            this.floorValue(product.lifeInsuranceMaxProgrammedPaymentFee * 100);

          if (this.displayInitialFees) {
            if (
              !this.maxInitialFees ||
              this.maxInitialFees < this.minInitialFees
            )
              this.maxInitialFees = this.minInitialFees;

            if (
              this.products
                .get(`${0}`)
                .get('parameters')
                .get('initialPaymentFeesPercent').value *
                100 <
              this.minInitialFees
            )
              this.products
                .get(`${0}`)
                .get('parameters')
                .get('initialPaymentFeesPercent')
                .setValue(this.minInitialFees);
          }

          if (this.displayMonthlyFees) {
            if (
              !this.maxMonthlyFees ||
              this.maxMonthlyFees < this.minMonthlyFees
            )
              this.maxMonthlyFees = this.minMonthlyFees;

            if (
              this.products
                .get(`${0}`)
                .get('parameters')
                .get('monthlyPaymentFeesPercent').value *
                100 <
              this.minMonthlyFees
            )
              this.products
                .get(`${0}`)
                .get('parameters')
                .get('monthlyPaymentFeesPercent')
                .setValue(this.minMonthlyFees);
          }
        });
    }
  }

  floorValue(value: number) {
    return Math.floor(value * 100) / 100;
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
